export default __webpack_public_path__ + "static/media/img-guide-gt-popup-3-be_fr.9db9cf98.png";